<template>
    <p :class="['field']">
      <PopupAlert
          :text="alertMessage"
          :popup-action="resetFile"
          v-show="showAlert"
      />
        <label v-if="required" :for="id" >
            <slot></slot>
            *<span v-if="helpText"> ({{ helpText }})</span>
        </label>
        <label v-else :for="id">
            <slot></slot>
            <span v-if="helpText"> ({{ helpText }})</span>
        </label>
        <input type="file"
               class="file-upload"
               size="30"
               :id="id"
               :name="id"
               ref="fileuploadref"
               :accept="accept"
               :disabled="disabled"
               @input="emitChange($event)"
        /><br/>
      <label class="btn btn_upload" :class="{'btn_grey disabled' : disabled}" v-on:click="onLabelClick()">{{showText}}</label>
    </p>
</template>

<script>
	import PopupAlert from "./PopupAlert.vue";

  export default {
		name: "FileInput",
    components: {PopupAlert},
		data() {
			return {
        value: null,
        filename: null,
        showAlert: false,
        alertMessage: "",
			}
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			id: String,
      helpText: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      buttonText:{
        type: String,
        default: "Nahrát soubor"
      },
      accept: String,
      disabled: Boolean,
      maxSize: Number,
		},
    computed: {
      showText: function (){
        return this.value ? this.value.substr(this.value.lastIndexOf('\\')+1) : this.buttonText;
      }
    },
		methods: {
			emitChange(event) {
        this.value = event.target.value;
        if(this.checkFileSize(event)) {
          this.$emit('change', event)
        }
			},
      checkFileSize(event){
        let file = event.target.files[0];
        if(this.maxSize && file.size / 1024 > this.maxSize){
          this.alertMessage = this.$gettextInterpolate(this.$gettext('Nahraný soubor nesmí být větší než %{maxSize}KB.'), { maxSize: this.maxSize });
          this.showAlert = true;
          return false
        }else{
          return true;
        }
      },
      onLabelClick(){
        this.$refs.fileuploadref.click();
      },
      resetFile(){
        this.showAlert = false;
        this.value = null;
        this.$refs.fileuploadref.value = null;
      }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/common/FileInput.vue